export default function Loader({ fullscreen = true, text = "" }) {
  const overlay = {
    position: fullscreen ? "fixed" : "relative",
    top: 0,
    left: 0,
    width: fullscreen ? "100vw" : "100%",
    height: fullscreen ? "100vh" : "100%",
    backgroundColor: fullscreen ? "rgba(255, 255, 255, 0.8)" : "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: fullscreen ? 100000 : "auto",
    flexDirection: "column",
  };

  const spinner = {
    width: "40px",
    height: "40px",
    border: "5px solid #ccc",
    borderTop: "5px solid #692a99",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  };

  const textStyle = {
    marginTop: "1rem",
    fontSize: "1rem",
    color: "#555",
  };

  const keyframes = `
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
    `;

  return (
    <>
      <style>{keyframes}</style>
      <div style={overlay}>
        <div style={spinner}></div>
        {text && <p style={textStyle}>{text}</p>}
      </div>
    </>
  );
}
